import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-proforms-rubric-competency-title',
  standalone: false,
  templateUrl: './proforms-rubric-competency-title.component.html',
  styleUrl: './proforms-rubric-competency-title.component.scss',
})
export class ProformsRubricCompetencyTitleComponent implements OnChanges {
  @ViewChild('competencyTitleInput')
  competencyTitleInput: ElementRef;

  @Input() title: string;

  @Input() currentTitleBeingEdited: string;

  @Output() readonly handleSaveEvent = new EventEmitter<string>();

  @Output() readonly handleTitleClicked = new EventEmitter<string>();

  updatedTitle: string;

  editMode = false;

  saving: boolean;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['title']) {
      this.updatedTitle = ` ${changes['title'].currentValue}`.slice(1);
    }
    if (changes['currentTitleBeingEdited']) {
      if (changes['currentTitleBeingEdited'].currentValue !== this.title) {
        this.editMode = false;
        this.updatedTitle = this.title;
      }
    }
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
    if (this.editMode) {
      this.handleTitleClicked.emit(this.title);
      setTimeout(() => {
        this.competencyTitleInput.nativeElement.focus();
      }, 100);
    } else {
      this.updatedTitle = this.title;
    }
  }

  saveTitle() {
    if (this.updatedTitle === this.title) {
      this.editMode = false;
      return;
    }
    this.saving = true;
    this.handleSaveEvent.emit(this.updatedTitle);
    setTimeout(() => {
      this.saving = false;
      this.editMode = false;
    }, 1000);
  }
}
